import { useEffect, useState } from "react";
import {
  getAuth,
  onAuthStateChanged,
} from "firebase/auth";

export default function useAuthStatus() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [checkingStatus, setCheckingStatus] =
    useState(true);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        setLoggedIn(Boolean(user));
        setCheckingStatus(false);
      }
    );

    return unsubscribe;
  }, []);

  return {
    loggedIn,
    checkingStatus,
  };
}